module.exports = __webpack_public_path__ + "static/media/dc_3.ba72f067.JPG";